module.exports = __webpack_public_path__ + "img/ui-checks-grid.34baa596.svg";